// src/components/profile/risk-profile-section.jsx
import React from 'react';
import { Target } from 'lucide-react';

const RiskProfileSection = ({ riskProfile }) => {
  // Default values if no risk profile data provided
  const {
    riskScore = 50,
    riskCategory = 'Balanced Manager',
  } = riskProfile || {};

  // Determine the risk categories based on score
  const getRiskCategoryDescription = (score) => {
    if (score >= 80) return 'Ultra-Differential Maverick';
    if (score >= 65) return 'High Risk Taker';
    if (score >= 45) return 'Balanced Manager';
    if (score >= 30) return 'Conservative';
    return 'Template Follower';
  };

  // If no explicit category provided, calculate based on score
  const displayCategory = riskCategory || getRiskCategoryDescription(riskScore);

  return (
    <div className="bg-black/30 rounded-lg p-4 border border-[#3f69ae]/20">
      <h4 className="text-lg font-medium text-[#44d5a3] mb-2 flex items-center">
        <Target size={18} className="mr-2 text-emerald-400" />
        Risk Profile <span className="inline-block ml-1">{riskScore >= 75 ? "🎯" : riskScore <= 25 ? "🛡️" : ""}</span>
      </h4>
      <div className="h-4 bg-gray-700 rounded-full overflow-hidden mb-2">
        <div 
          className="h-full bg-gradient-to-r from-blue-500 via-teal-500 to-emerald-500 relative"
          style={{ width: `${riskScore}%` }}
        >
          {/* Small pointer indicator at the exact score */}
          <div className="absolute right-0 top-0 h-full w-1 bg-white"></div>
        </div>
      </div>
      <div className="flex justify-between text-xs text-gray-400">
        <span>Template</span>
        <span>Balanced</span>
        <span>Differential</span>
      </div>
      <p className="mt-3 text-sm text-gray-300">
        {riskScore >= 66 ? 
          "You regularly make bold, differential picks that set you apart from the crowd. A true maverick who charts their own path!" :
          riskScore <= 33 ? 
            "You prefer the security of template players and popular picks. A disciplined manager who values consistency and proven performance." :
            "You balance template picks with calculated differential selections. A thoughtful manager who knows when to follow the crowd and when to diverge."
        }
      </p>
      <p className="mt-1 text-xs text-emerald-400 font-medium">
        Score: {Math.round(riskScore)}/100 • {displayCategory}
      </p>
    </div>
  );
};

export default RiskProfileSection;